// @flow
let count: number = 0;

export const resetId = (): void => {
  count = 0;
};

export const getNextId = (): string => {
  const id: string = `element-id-${count}`;
  count += 1;
  return id;
};



// WEBPACK FOOTER //
// ../react-lib/src/utils/elementIdCreator.js